import type { Dispatch as ReduxDispatch } from '@reduxjs/toolkit';

import type { ElasticSearchResponse } from '../@types/ElasticSearchResponse';
import type { Faq } from '../@types/Faq';
import type { BaseAction } from '../@types/actions';
import * as http from '../Http';
import { buildGetRequest } from '../Http/requestTemplates';
import type QueryFilter from '../helpers/query-filter';
import requestCache from '../utils/request-cache';

export const REQ_SEARCH_FAQ = 'REQ/FAQ_SEARCH';
export const RCV_SEARCH_FAQ = 'RCV/FAQ_SEARCH';
type REQ_SEARCH_FAQ_TYPE = BaseAction<typeof REQ_SEARCH_FAQ>;
type RCV_SEARCH_FAQ_TYPE = BaseAction<typeof RCV_SEARCH_FAQ> & {
  response: ElasticSearchResponse<Faq>;
};

export const REQ_CLEAR_FAQ = 'REQ/FAQ_CLEAR';
type REQ_CLEAR_FAQ_TYPE = BaseAction<typeof REQ_CLEAR_FAQ>;

export const REQUEST_FAILED = 'FAQ/REQUEST_FAILED';
type REQUEST_FAILED_TYPE = BaseAction<typeof REQUEST_FAILED> & {
  action: typeof REQ_SEARCH_FAQ;
};

export type FAQ_ACTION =
  | REQ_SEARCH_FAQ_TYPE
  | RCV_SEARCH_FAQ_TYPE
  | REQ_CLEAR_FAQ_TYPE
  | REQUEST_FAILED_TYPE;

type Dispatch = ReduxDispatch<FAQ_ACTION>;

const getFilterQueryString = (queryFilter?: QueryFilter) => {
  if (!queryFilter || queryFilter.isEmpty()) return '';

  return `?filter=${queryFilter.toQueryStringFilter()}`;
};

export const search = (queryFilter?: QueryFilter) => async (dispatch: Dispatch) => {
  if (requestCache.isPending(REQ_SEARCH_FAQ)) {
    return;
  }
  requestCache.isPending(REQ_SEARCH_FAQ, true);

  try {
    dispatch({ type: REQ_SEARCH_FAQ });

    const response = await http.json<ElasticSearchResponse<Faq>>(
      `/api/faq${getFilterQueryString(queryFilter)}`,
      buildGetRequest(),
    );
    http.validateResponse(response);
    dispatch({
      type: RCV_SEARCH_FAQ,
      response: response.response,
    });
  } catch (_e) {
    dispatch({ type: REQUEST_FAILED, action: REQ_SEARCH_FAQ });
  }
  requestCache.isPending(REQ_SEARCH_FAQ, false);
};

export const clear = () => (dispatch: Dispatch) => dispatch({ type: REQ_CLEAR_FAQ });
